export default __webpack_public_path__ + "static/media/ybx_logo_light_tn.b3b75777.svg";